import env from 'simulix-shared/env';
import features from 'simulix-shared/featureFlags';

const { NODE_ENV, API_PROTOCOL, API_HOST, API_PORT, AUTH_AUTHORITY, AUTH_CLIENT_ID, SENTRY_DSN } =
  env;

const config = {
  env: NODE_ENV || 'development',
  features,
  apiBaseUrl: `${API_PROTOCOL || 'http'}://${API_HOST || 'localhost'}:${API_PORT || '8888'}`,
  frontendURL: window.location.origin,
  auth: {
    authority: AUTH_AUTHORITY || 'http://localhost:8085/auth/realms/simulix',
    clientId: AUTH_CLIENT_ID || 'simulixlocal',
  },
  instances: {
    startTimeout: Number(env.INSTANCES_START_TIMEOUT || 1000),
  },
  sentryDsn: SENTRY_DSN,
};

export default config;
